var map = {
	"./aiChat.js": "./src/store/modules/aiChat.js",
	"./align.js": "./src/store/modules/align.js",
	"./app.js": "./src/store/modules/app.js",
	"./audio.js": "./src/store/modules/audio.js",
	"./auxiliary_toolbar.js": "./src/store/modules/auxiliary_toolbar.js",
	"./body.js": "./src/store/modules/body.js",
	"./color.js": "./src/store/modules/color.js",
	"./errorLog.js": "./src/store/modules/errorLog.js",
	"./fieldList.js": "./src/store/modules/fieldList.js",
	"./filter.js": "./src/store/modules/filter.js",
	"./globalSearch.js": "./src/store/modules/globalSearch.js",
	"./historical_records.js": "./src/store/modules/historical_records.js",
	"./job.js": "./src/store/modules/job.js",
	"./lowCode.js": "./src/store/modules/lowCode.js",
	"./module_edit.js": "./src/store/modules/module_edit.js",
	"./offline_atlas.js": "./src/store/modules/offline_atlas.js",
	"./options.js": "./src/store/modules/options.js",
	"./poster.js": "./src/store/modules/poster.js",
	"./report.js": "./src/store/modules/report.js",
	"./resume.js": "./src/store/modules/resume.js",
	"./screen.js": "./src/store/modules/screen.js",
	"./settings.js": "./src/store/modules/settings.js",
	"./user.js": "./src/store/modules/user.js",
	"./widgets.js": "./src/store/modules/widgets.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/store/modules sync recursive \\.js$";